import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

import { AuthService } from '@service/auth.service';
import { UsersService } from '@service/users.service';

import { Profile } from '@model/Profile';
import { Message } from '@model/Message';

@Component({
  selector: 'app-modal-researcher-profile',
  templateUrl: './modal-researcher-profile.component.html',
  styleUrls: ['./modal-researcher-profile.component.scss']
})
export class ModalResearcherProfileComponent implements OnInit {
  public form: FormGroup;
  public submitted: boolean = false;
  public profiles = [];

  constructor(
    private readonly formBuilder: FormBuilder,
    public readonly activeModal: NgbActiveModal,
    private readonly toast: ToastrService,
    private readonly usersService: UsersService,
    private readonly authService: AuthService,
  ) {
    this.profiles = this.usersService.PROFILE_CODS;
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      profile_type: ['', Validators.required],
    });
  }

  save() {
    this.submitted = true;

    if (this.form.invalid) {
      return;
    }

    this.submitted = false;
    const formData: { profile_type: string; } = this.form.value;

    this.usersService.updateResearchProfileType(this.authService.user.id, formData.profile_type)
      .subscribe(() => {
        const currentUser = this.authService.user;
        const profile: Profile = {...currentUser, profile_type: formData.profile_type };

        localStorage.setItem('currentUser', JSON.stringify(profile));

        this.toast.success(Message.SUCCESS);
        this.activeModal.close();
      });
  }
}
